import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';

import Loading from 'app/components/loaders/Loading';

import useQuery from 'app/hooks/useQuery';
import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    form: {
        maxWidth: '320px'
    },
    marginTop: {
        marginTop: theme.spacing(3),
    },
}));

export default function WelcomeRedirect (props) {

    const { app, handleApp, hydrateApp } = useApp();
    let query = useQuery();
    const api = useApi();
    const classes = useStyles();
    const history = useHistory();
    const [ errors, setErrors ] = useState({});
    const { onLoading, loading } = props;

    useEffect(() => {

        onLoading(true);

        const queryUsername = query.get('__u');
        const queryToken = query.get('__tok');

        if (! queryUsername || ! queryToken) {
            setErrors({general: 'We could not validate your request. Please try the password reset link to reset your account password.'})
            onLoading(false);
        }

        const data = {
            username: queryUsername,
            password: queryToken,
        }

        api.post(process.env.MIX_WEB_BASEURL + '/login', data)
            .then(() => {
                hydrateApp();
                history.push('/');
            }).catch(error => {
                if (error?.response?.data?.errors) setErrors(error.response.data.errors);
                onLoading(false)
            });

    }, []);

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    }

    return (
        <div className={classes.form}>
            <Loading isLoading={loading}/>
            <Typography component="div" align="center" variant="subtitle1" color="textSecondary" gutterBottom>
                Welcome to {app.club ? app.club.name : 'Club Apps'}
            </Typography>
            {isError('general') &&
                <Alert severity="error">{getErrorMessage('general')}</Alert>
            }
            <Typography component="div" align="center" variant="subtitle2" className={classes.marginTop}>
                <Link component={RouterLink} to="/support/login" color="secondary">
                    Forgot Username or Email?
                </Link>
                <br/>
                <Link component={RouterLink} to="/password/email" color="secondary">
                    Forgot Password?
                </Link>
            </Typography>
        </div>
    );
}
